module.exports = __webpack_public_path__ + "img/astral_21.c0d0911d.svg";